// Array to hold the data for each Accordian Item with the individual list Anchors of inside and their corresponding names and paths

let accordionNavigationGb = [
	{
	accordionItem : {name :'resources', icon :'resources'},
	anchors : [
		{path: '/training/courses', name: 'On-Demand'},
		{path: '/training/podcasts', name: 'Podcasts'},
		{path: '/training/interactive-webinars', name: 'Interactive Webinars'},
		{path: '/training/webinars', name: 'Webinars'},
		{path: '/news', name: 'News'},
		{path: '/blog', name: 'The Networking Blog'},
		{path: '/magazine', name: 'In Touch Magazine'},
		{path: '/documents', name: 'Downloads'}
	]
},
{
	accordionItem : {name :'network', icon :'network'},
	anchors : [
		{path: '/members', name: 'Member Search'},
		{path: '/events', name: 'Events'},
		{path: '/forums', name: 'Forum'},
		{path: '/networking/conversations', name: 'Messages'},
	]
},
{
	accordionItem : {name :'your office', icon :'profile'},
	anchors : [
		{path: '/writing-services', name: 'CV Services'},
//		{path: '/ask-an-expert', name: 'Ask An Expert'},
		{path: '/consultancy', name: 'Consultancy'},
		{path: '/partnerships-overview', name: 'Partnerships'},
		{path: '/testimonials', name: 'Testimonials'}
	]
},
{
	accordionItem : {name :'work', icon :'work'},
	anchors : [
		{path: '/jobs', name: 'Jobs Board'},
		{path: '/my-jobs-section/my-applications', name: 'My Applications'},
		{path: '/my-jobs-section/saved-searches', name: 'Saved Searches'},
		{path: '/my-jobs-section/favourite-jobs', name: 'Favourite Jobs'},
		{path: '/my-jobs', name: 'My Jobs'}
	]
},
{
	accordionItem : {name :'account', icon :'account'},
	anchors : [
		{path: '/profile', name: 'Profile'},
		{path: '/stars', name: 'Stars'},
		{path: '/contact-us', name: 'Contact Us'},
		{path: '/account/basic', name: 'Settings'},
		{path: '/logout', name: 'Logout'},
	]
}
];

// Array to hold the data for each Accordian Item with the individual list Anchors of inside and their corresponding names and paths


//US Nav bar hides the 'your office' section.
let accordionNavigationUs = [
{
	accordionItem : {name :'resources', icon :'resources'},
	anchors : [
		{path: '/training/courses', name: 'On-Demand'},
		{path: '/training/podcasts', name: 'Podcasts'},
		{path: '/training/interactive-webinars', name: 'Interactive Webinars'},
		{path: '/training/webinars', name: 'Webinars'},
		{path: '/news', name: 'News'},
		{path: '/blog', name: 'The Networking Blog'},
		{path: '/magazine', name: 'In Touch Magazine'},
		{path: '/documents', name: 'Downloads'}
	]
},
{
	accordionItem : {name :'network', icon :'network'},
	anchors : [
		{path: '/members', name: 'Member Search'},
		{path: '/events', name: 'Events'},
		{path: '/forums', name: 'Forum'},
		{path: '/networking/conversations', name: 'Messages'},
	]
},
{
	accordionItem : {name :'work', icon :'work'},
	anchors : [
		{path: '/jobs', name: 'Jobs Board'},
		{path: '/my-jobs-section/my-applications', name: 'My Applications'},
		{path: '/my-jobs-section/saved-searches', name: 'Saved Searches'},
		{path: '/my-jobs-section/favourite-jobs', name: 'Favorite Jobs'},
		{path: '/my-jobs', name: 'My Jobs'}
	]
},

// {
// 	accordionItem : {name :'your office', icon :'profile'},
// 	anchors : [
// 		{path: '/writing-services', name: 'CV Services'},
// 		{path: '/ask-an-expert', name: 'Ask An Expert'},
// 		{path: '/consultancy', name: 'Consultancy'},
// 		{path: '/partnerships-overview', name: 'Partnerships'},
// 		{path: '/testimonials', name: 'Testimonials'}
// 	]
// },
{
	accordionItem : {name :'account', icon :'account'},
	anchors : [
		{path: '/profile', name: 'Profile'},
		{path: '/stars', name: 'Stars'},
		{path: '/contact-us', name: 'Contact Us'},
		{path: '/account/basic', name: 'Settings'},
		{path: '/logout', name: 'Logout'},
	]
}
];

export { accordionNavigationGb, accordionNavigationUs };


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/navigationData.js